import PropTypes from 'prop-types';
import React from 'react';
import { InView } from 'react-intersection-observer';
import { ImageContainer } from './PlayImage.styles';
import Image from './Image';

const InViewWrapper = ({ ssr, children }) => {
    if (ssr) {
        return children({ inView: true });
    }

    return (
        <InView rootMargin="200px 0px" triggerOnce>
            {children}
        </InView>
    );
};

const PlayImage = ({
    src,
    srcSet,
    sizes,
    alt = '',
    height,
    width,
    imageRatio = '16-9',
    ssr,
    children,
    blurred,
    opacity,
    showPlaceholder,
    className,
}) => {
    return (
        <InViewWrapper ssr={ssr}>
            {({ inView, ref }) => (
                <ImageContainer imageRatio={imageRatio} ref={ref} className={className} opacity={opacity}>
                    <Image
                        key={src}
                        width={width}
                        height={height}
                        data-src={src}
                        src={src}
                        srcSet={srcSet}
                        sizes={sizes}
                        alt={alt}
                        inView={inView}
                        blurred={blurred}
                        showPlaceholderImage={showPlaceholder}
                        opacity={opacity}
                        ssr={ssr}
                    />
                    {children}
                </ImageContainer>
            )}
        </InViewWrapper>
    );
};

PlayImage.propTypes = {
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    imageRatio: PropTypes.oneOf(['16-9', 'cinema', 'square', 'imax', '2-3']),
    ssr: PropTypes.bool,
    source: PropTypes.element,
    blurred: PropTypes.bool,
};

PlayImage.defaultProps = {
    alt: '',
    imageRatio: '16-9',
    source: null,
};

export default PlayImage;
